// extracted by mini-css-extract-plugin
export var box = "_40-0";
export var check = "_40-1";
export var checkboxButton = "_40-6";
export var checkboxGroup = "_40-5";
export var disabled = "_40-7";
export var ghost = "_40-9";
export var input = "_40-2";
export var label = "_40-4";
export var normal = "_40-8";
export var uncheck = "_40-3";